exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-container {\n  display: inline-block;\n  margin: 10px 1% 10px 1%;\n}\n.field-container select {\n  background-repeat: no-repeat;\n  background-position: 95% center;\n  width: 100%;\n}\n.field-container select option {\n  text-align: left;\n  color: var(--color-select-option);\n}\n.field-container input {\n  background-repeat: no-repeat;\n  background-position: 95% center;\n  width: 100%;\n}\n.field-container.col-12 {\n  width: 97%;\n}\n.field-container.col-6 {\n  width: 47%;\n}\n.field-container.col-3 {\n  width: 30.3%;\n}\n.field-container.col-2 {\n  width: 16.5%;\n}\n.field-container.col-9 {\n  width: 66%;\n}", ""]);

// exports
